import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
  selector: "ab-attr-group",
  templateUrl: "./attr-group.component.html",
})
export class AttrGroupComponent {
  @Input() public attrs: any;
  @Output() public deleted = new EventEmitter();
  public pageSize = 10;
  public isHovered = false;

  public deleteAttr($event: Event, attr: any) {
    $event.stopPropagation();
    return this.deleted.emit(attr);
  }

  public groupsShowParams(attr: any, item: any) {
    return { tab: "notice-list", filters: { [attr.key]: item.id } };
  }

  public trackBy(_index: number, attr: any) {
    return attr.key;
  }

  public trackById(_index: number, item: any) {
    return item.id;
  }

  public showPagination(count: number) {
    return count > this.pageSize;
  }
}
